<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Banco</mat-label>
      <input
        type="text"
        matInput
        formControlName="bank"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (type of listTypeFiltered | async; track type.id) {
          <mat-option [value]="type.id" class="border-bottom-select">
            <div class="text-xs">
              {{ type.cod_banco }} | {{ type.descricao }}
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Agência</mat-label>
      <input matInput formControlName="bank_branch" />
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Conta</mat-label>
      <input matInput formControlName="bank_account" />
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Pix</mat-label>
      <input matInput formControlName="pix" />
    </mat-form-field>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.edit) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading || !checkBank()"
        (click)="editBankDetails()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading || !checkBank()"
        (click)="createBankDetails()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
